import {
  privacyPolicyMarkdown,
  subscriptionTermsMarkdown,
  termsOfUseMarkdown,
} from './content';

const contactHeaderPhoneLineUs =
  '**Contact:** {{SUPPORT_EMAIL}}  \n**Phone:** {{SUPPORT_PHONE_US}}';

// Compliance: US traffic must name TECHWAVE in §1 (non-US keeps Cyprus-oriented base in content.ts).
export const privacyPolicyMarkdownUs = privacyPolicyMarkdown
  .replace(
    /The data controller is: \*\*\{\{COMPANY_LEGAL_NAME\}\}\*\*, contact email: \*\*\{\{SUPPORT_EMAIL\}\}\*\*\./,
    'The data controller is: **TECHWAVE SOLUTIONS LIMITED**, with registered address at **9205 West Russell Road, Building 3, Suite 240, Las Vegas, NV 89148, USA**, contact email: **{{SUPPORT_EMAIL}}**.',
  )
  .replace(
    /\*\*Contact:\*\* \{\{SUPPORT_EMAIL\}\}\n\n## IMPORTANT PRIVACY INFORMATION/,
    `${contactHeaderPhoneLineUs}\n\n## IMPORTANT PRIVACY INFORMATION`,
  );

export const subscriptionTermsMarkdownUs = subscriptionTermsMarkdown.replace(
  /\*\*Contact:\*\* \{\{SUPPORT_EMAIL\}\}\n\n## 1\. Trial/,
  `${contactHeaderPhoneLineUs}\n\n## 1. Trial`,
);

export const termsOfUseMarkdownUs = termsOfUseMarkdown
  .replace(
    /1\. These Terms govern your use of \{\{WEBSITE_URL\}\} and related services\/content, provided by \{\{COMPANY_LEGAL_NAME\}\}, a company incorporated under the laws of the Republic of Cyprus, having its registered office at \{\{COMPANY_LEGAL_ADDRESS\}\}\./,
    '1. These Terms govern your use of {{WEBSITE_URL}} and related services/content, provided by TECHWAVE SOLUTIONS LIMITED, with registered address at 9205 West Russell Road, Building 3, Suite 240, Las Vegas, NV 89148, USA.',
  )
  .replace(
    /\*\*Contact:\*\* \{\{SUPPORT_EMAIL\}\}\n\n> The Service/,
    `${contactHeaderPhoneLineUs}\n\n> The Service`,
  );
